/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserAccessRelationshipsResponse
 */
export interface UserAccessRelationshipsResponse {
    /**
     * 
     * @type {number}
     * @memberof UserAccessRelationshipsResponse
     */
    managedTeams: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessRelationshipsResponse
     */
    assignedPeople: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessRelationshipsResponse
     */
    playerAssignments: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessRelationshipsResponse
     */
    ownedTournaments: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessRelationshipsResponse
     */
    ownedLeagues: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessRelationshipsResponse
     */
    ownedTrainings: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessRelationshipsResponse
     */
    claimedTrainingPlayers: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessRelationshipsResponse
     */
    matchedPeopleByEmail: number;
}

/**
 * Check if a given object implements the UserAccessRelationshipsResponse interface.
 */
export function instanceOfUserAccessRelationshipsResponse(value: object): value is UserAccessRelationshipsResponse {
    if (!('managedTeams' in value) || value['managedTeams'] === undefined) return false;
    if (!('assignedPeople' in value) || value['assignedPeople'] === undefined) return false;
    if (!('playerAssignments' in value) || value['playerAssignments'] === undefined) return false;
    if (!('ownedTournaments' in value) || value['ownedTournaments'] === undefined) return false;
    if (!('ownedLeagues' in value) || value['ownedLeagues'] === undefined) return false;
    if (!('ownedTrainings' in value) || value['ownedTrainings'] === undefined) return false;
    if (!('claimedTrainingPlayers' in value) || value['claimedTrainingPlayers'] === undefined) return false;
    if (!('matchedPeopleByEmail' in value) || value['matchedPeopleByEmail'] === undefined) return false;
    return true;
}

export function UserAccessRelationshipsResponseFromJSON(json: any): UserAccessRelationshipsResponse {
    return UserAccessRelationshipsResponseFromJSONTyped(json, false);
}

export function UserAccessRelationshipsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAccessRelationshipsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'managedTeams': json['managedTeams'],
        'assignedPeople': json['assignedPeople'],
        'playerAssignments': json['playerAssignments'],
        'ownedTournaments': json['ownedTournaments'],
        'ownedLeagues': json['ownedLeagues'],
        'ownedTrainings': json['ownedTrainings'],
        'claimedTrainingPlayers': json['claimedTrainingPlayers'],
        'matchedPeopleByEmail': json['matchedPeopleByEmail'],
    };
}

export function UserAccessRelationshipsResponseToJSON(json: any): UserAccessRelationshipsResponse {
    return UserAccessRelationshipsResponseToJSONTyped(json, false);
}

export function UserAccessRelationshipsResponseToJSONTyped(value?: UserAccessRelationshipsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'managedTeams': value['managedTeams'],
        'assignedPeople': value['assignedPeople'],
        'playerAssignments': value['playerAssignments'],
        'ownedTournaments': value['ownedTournaments'],
        'ownedLeagues': value['ownedLeagues'],
        'ownedTrainings': value['ownedTrainings'],
        'claimedTrainingPlayers': value['claimedTrainingPlayers'],
        'matchedPeopleByEmail': value['matchedPeopleByEmail'],
    };
}

